/**
 * CollectionEmptyState.tsx
 * ----------------
 * Renders an empty state indicator for Fluent UI collections.
 */

import * as React from 'react';

import { FluentSvgIcon } from './FluentSvgIcon';

/**
 * Component properties
 */

interface CollectionEmptyStateProps {
    icon?: string;
    message: string;
}

/**
 * Show an empty state for a Fluent UI collections.
 * @param props Component properties
 */
export const CollectionEmptyState = (props: CollectionEmptyStateProps) => {
    const { icon, message } = props;

    // Default the icon to PageListFiler
    const iconName = icon === undefined ? 'PageListFilter' : icon;

    return (
        <div className="collection-empty-state">
            <FluentSvgIcon iconName={iconName} height={14} width={14} /> {message}
        </div>
    );
};
